// Shared code block formatting instruction for all providers
export const getCodeFormattingInstructions = () => `You must format all code examples using markdown code blocks with explicit language identifiers.

For example, Python code should be formatted as:
\`\`\`python
def example():
    print("Hello World")
\`\`\`

JavaScript code should be formatted as:
\`\`\`javascript
function example() {
    console.log("Hello World");
}
\`\`\`

TypeScript code should be formatted as:
\`\`\`typescript
interface Example {
    name: string;
}
\`\`\`

Always follow these rules:
1. Always wrap code in markdown code blocks
2. Always specify the language identifier
3. Use proper indentation
4. Include comments for complex code
5. Format the code according to the language's conventions

Never provide code without the proper markdown code block syntax and language identifier.`;

export const enhanceSystemPrompt = (existingPrompt?: string) => {
  const codeInstructions = getCodeFormattingInstructions();
  return existingPrompt 
    ? `${codeInstructions}\n\n${existingPrompt}`
    : codeInstructions;
};